var React = require('react');

function BettingIconInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"opacity":"0.7","cx":"12.5","cy":"12.5","r":"12.5","fill":"#FFDBDB","key":0}),React.createElement("path",{"d":"M11.6875 13.667C11.4807 14.5091 11.2148 15.2034 10.5943 16.075C11.6875 16.725 12.5739 16.725 13.667 16.075C13.0614 15.2034 12.7807 14.5091 12.5739 13.667C13.9773 15.4545 15.8239 14.642 15.8239 12.7364C15.8239 11.9682 15.2034 10.8898 12.1307 8.4375C9.05795 10.8898 8.4375 11.9682 8.4375 12.7364C8.4375 14.642 10.2841 15.4545 11.6875 13.667Z","fill":"#F7685B","key":1})]);
}

BettingIconInline.defaultProps = {"width":"25","height":"25","viewBox":"0 0 25 25","fill":"none"};

module.exports = BettingIconInline;

BettingIconInline.default = BettingIconInline;
